<ul class="card-nav d-flex flex-column">

  <li *ngIf="selectedAlarm" [class.active]="selectedTab === 'progress'" (click)="selectTab('progress')"
    matTooltip="Progress" matTooltipPosition="right">
    <i class="fa fa-check-circle-o" aria-hidden="true"></i>
  </li>

  <li *ngIf="selectedAlarm && !isWorkflowHidden" [class.active]="selectedTab === 'workflow'"
    (click)="selectTab('workflow')" [class.disabled]="isDisabledWorkflow"
    [style.pointer-events]="isDisabledWorkflow ? 'none' : 'auto'" matTooltip="Workflow" matTooltipPosition="right">
    <i class="fa fa-address-book-o" aria-hidden="true"></i>
  </li>

  <li *ngIf="selectedAlarm" [class.active]="selectedTab === 'actions'" (click)="selectTab('actions')"
    matTooltip="Actions" matTooltipPosition="right">
    <i class="fa fa-list" aria-hidden="true"></i>
  </li>

  <li [class.active]="selectedTab === 'map'" (click)="selectTab('map')" matTooltip="Map" matTooltipPosition="right">
    <i class="fa fa-map-marker" aria-hidden="true"></i>
  </li>

  <li [class.active]="selectedTab === 'zone'" (click)="selectTab('zone')" *ngIf="isContainZone" matTooltip="Zone"
    matTooltipPosition="right">
    <i class="fa fa-crop" aria-hidden="true"></i>
  </li>

  <li *ngIf="selectedAlarm" [class.active]="selectedTab === 'assets'" (click)="selectTab('assets')" matTooltip="Assets"
    matTooltipPosition="right">
    <i class="fa fa-file-text-o" aria-hidden="true"></i>
  </li>

  <li *ngIf="!isWorkflowHidden" [class.active]="selectedTab === 'send-alarm'" (click)="selectTab('send-alarm')"
    matTooltip="Send Alarm" matTooltipPosition="right">
    <i class="fa fa-plus" aria-hidden="true"></i>
  </li>

  <li [class.active]="selectedTab === 'chatbot'" (click)="selectTab('chatbot')"
    [class.disabled]="alarmService.isAskRamsysActive"
    [style.pointer-events]="alarmService.isAskRamsysActive ? 'none' : 'auto'" matTooltip="Ask RAMsys"
    matTooltipPosition="right">
    <img src="./assets/images/chaticon.svg" alt="chatbot" class="chatbot-icon" />
  </li>

  <li [class.active]="selectedTab === 'controllers'" (click)="selectTab('controllers')" matTooltip="Controllers"
    *ngIf="selectedAlarm && isContainZone && !isWorkflowHidden" matTooltipPosition="right">
    <i class="fa fa-cogs" aria-hidden="true"></i>
  </li>

  <li [class.active]="selectedTab === 'branch-controls'" (click)="selectTab('branch-controls')"
    matTooltip="Branch Controls" matTooltipPosition="right">
    <i class="fa fa-sliders" aria-hidden="true"></i>
  </li>

  <li [class.active]="selectedTab === 'create-task'" (click)="selectTab('create-task')" matTooltip="Tasks"
    matTooltipPosition="right">
    <i class="fa fa-address-card-o" aria-hidden="true"></i>
    <span *ngIf="hasNewTaskNotification" class="notification-dot"></span>
  </li>

</ul>